import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-apple-gray mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-6 h-6 bg-apple-blue rounded-md flex items-center justify-center">
                <span className="text-white font-bold text-[10px]">B</span>
              </div>
              <span className="font-semibold text-apple-gray-dark">Biet Es Runter</span>
            </div>
            <p className="text-xs text-apple-gray-mid leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-apple-gray-dark text-sm mb-3">{t('footer.explore')}</h4>
            <ul className="space-y-2">
              {[
                ['/', t('footer.home')],
                ['/search', t('footer.listings')],
                ['/search?category=electronics', t('footer.electronics')],
                ['/search?category=bicycles', t('footer.bicycles')],
              ].map(([to, label]) => (
                <li key={to}><Link to={to} className="text-xs text-apple-gray-mid hover:text-apple-gray-dark transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-apple-gray-dark text-sm mb-3">{t('footer.account')}</h4>
            <ul className="space-y-2">
              {[
                ['/login', t('footer.login')],
                ['/register', t('footer.register')],
                ['/create', t('footer.post_listing')],
                ['/my-listings', t('footer.my_listings')],
              ].map(([to, label]) => (
                <li key={to}><Link to={to} className="text-xs text-apple-gray-mid hover:text-apple-gray-dark transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-apple-gray-dark text-sm mb-3">{t('footer.support')}</h4>
            <ul className="space-y-2">
              {[
                t('footer.help_center'),
                t('footer.security'),
                t('footer.privacy'),
                t('footer.terms'),
              ].map((label) => (
                <li key={label}><Link to="#" className="text-xs text-apple-gray-mid hover:text-apple-gray-dark transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-apple-gray-mid">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-apple-gray-mid">🇩🇪 Deutschland</span>
            <span className="text-xs text-apple-gray-mid">€ EUR</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
